import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'outline';
  size?: 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'lg',
  fullWidth = false,
  className = '',
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-lg transition-all duration-200 uppercase tracking-wider';
  const variants = {
    primary: 'bg-brand hover:bg-brand-hover text-white shadow-[0_0_20px_rgba(255,107,0,0.3)] hover:shadow-[0_0_30px_rgba(255,107,0,0.5)]',
    outline: 'border-2 border-brand text-brand hover:bg-brand hover:text-white'
  };
  const sizes = {
    md: 'px-4 py-2.5 text-xs md:px-6 md:py-3 md:text-sm',
    lg: 'px-5 py-3 text-sm md:px-8 md:py-4 md:text-base',
    xl: 'px-6 py-3.5 text-sm md:px-10 md:py-5 md:text-lg'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`;
  if (href) {
    return <motion.a href={href} className={classes} onClick={props.onClick as React.MouseEventHandler} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} data-id="element-156">
        {children}
      </motion.a>;
  }
  return <motion.button className={classes} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} {...props} data-id="element-157">
      {children}
    </motion.button>;
}